module.exports = __webpack_public_path__ + "static/media/06.62418bd1.png";